import React from 'react';
import { billingPiletModals, PaymentGatewayProps } from '@sharefiledev/billing-pilet-sdk';
import { OverlayModalComponentProps } from '@sharefiledev/sharefile-appshell';
import { Spin } from 'antd';

export * from './AddressForm';
export * from './AddressFormContext';
export * from './CreditCardInfoPaymentGateway';
export * from './AccountAndBillingAddressForm';

export type PaymentGatewayOverlayProps = PaymentGatewayProps &
	Pick<
		OverlayModalComponentProps<typeof billingPiletModals.creditCardModal>,
		'completeInteraction' | 'cancelInteraction' | 'updateModalProps'
	>;

const LazyPaymentGatewayOverlay = React.lazy(() => import('./PaymentGateway'));
export const AsyncCreditCardModal: React.FC<PaymentGatewayOverlayProps> = props => (
	<React.Suspense fallback={<Spin />}>
		{<LazyPaymentGatewayOverlay {...props} />}
	</React.Suspense>
);
